import {
  POINT_CLOUD_STYLING_DEFAULTS,
  PointCloudClassification,
  PointCloudStyling,
  PointCloudStylingUOM,
} from '@trimble/types';

export interface PointCloudStylingContainerProps {
  styling: PointCloudStyling;
  classifications: PointCloudClassification[];
  elevationPicking: boolean;
  elevationPicked: number;
  uom: PointCloudStylingUOM;
  onStylingChange?(styling: PointCloudStyling): void;
  onElevationPickingToggle?(enabled: boolean): void;
}

export const POINT_CLOUD_STYLING_CONTAINER_DEFAULTS: PointCloudStylingContainerProps =
  {
    styling: POINT_CLOUD_STYLING_DEFAULTS,
    classifications: [],
    elevationPicking: false,
    elevationPicked: 0,
    uom: {
      unitLabel: 'm',
      meterToUnitFactor: 1,
    },
  };
